(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["powertex-fit-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.ptx-fit a[href^="#ptx-fit-"]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'auto', block: 'start' });
    history.replaceState(null, '', link.getAttribute('href'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powertex-paid-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.ptxReady === 'true') return;
      root.dataset.ptxReady = 'true';
      const selector = root.querySelector('[data-ptx-variant]');
      const price = root.querySelector('[data-ptx-price]');
      const mobilePrice = root.querySelector('[data-ptx-mobile-price]');
      const submit = root.querySelector('[data-ptx-submit]');
      if (!selector) return;
      selector.addEventListener('change', () => {
        const option = selector.options[selector.selectedIndex];
        const amount = option.dataset.price;
        const available = option.dataset.available === 'true';
        if (price) price.textContent = amount;
        if (mobilePrice) mobilePrice.textContent = amount;
        if (submit) submit.disabled = !available;
      });
    };
    const initializeAll = () => document.querySelectorAll('[data-ptx-paid]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-ptx-paid]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
